import { TableHeaderDefinitionCellType } from '~/components/organism/Table/types';
import TEST_ID from './index.testid';
import TableHeaderCell from '~/components/organism/Table/components/Header/utils';
import { SortDirection } from '~/graphql/types';
import { truncate } from 'lodash';

export type SortToggleFunction = (
  sortField: string,
  sortDirection: SortDirection | null,
) => void;

export const columns = (
  onSort: SortToggleFunction,
): Array<TableHeaderDefinitionCellType<any>> => [
  TableHeaderCell.string({
    label: 'Naam',
    dataProperty: 'name',
    width: 100,
    dataTestId: TEST_ID.NAME,
    sorting: {
      onSort: sortDirection => onSort('name', sortDirection),
    },
  }),
  TableHeaderCell.string({
    label: 'Velden',
    dataProperty: 'fields',
    dataTestId: TEST_ID.FIELDS,
    width: 250,
    renderFunction: (value: string) =>
      truncate(value, {
        length: 50,
        separator: ' ',
      }),
  }),

  TableHeaderCell.action({
    dataTestId: TEST_ID.ACTION,
  }),
];
